<script>
import { Line, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'WaterChart',
  extends: Line,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = tooltipItem.yLabel;
                    let unit = 'mL';
                    if (label) {
                        label += ': ';
                    }
                    if (value > 1000000000000000) {
                        unit = 'TL';
                        value = Math.round(value / 1000000000000000 * 10) / 10
                    } else if (value > 1000000000000) {
                        unit = 'GL';
                        value = Math.round(value / 1000000000000 * 10) / 10
                    } else if (value > 1000000000) {
                        unit = 'ML';
                        value = Math.round(value / 1000000000 * 10) / 10
                    } else if (value > 1000000) {
                        unit = 'kL';
                        value = Math.round(value / 1000000 * 10) / 10
                    } else if (value > 1000) {
                        unit = 'L';
                        value = Math.round(value / 1000 * 10) / 10
                    } else {
                        value = Math.round(value * 10) / 10
                    }

                    label += value + ' ' + unit;
                    return label;
                }
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
            }],
            yAxes: [{
                ticks: {
                  min: 0,
                    callback: function(inputValue, index, values) {
                      let label = '';
                      let value = inputValue;
                      let unit = 'mL';
                      if (value > 1000000000000000) {
                          unit = 'TL';
                          value = Math.round(value / 1000000000000000 * 10) / 10
                      } else if (value > 1000000000000) {
                          unit = 'GL';
                          value = Math.round(value / 1000000000000 * 10) / 10
                      } else if (value > 1000000000) {
                          unit = 'ML';
                          value = Math.round(value / 1000000000 * 10) / 10
                      } else if (value > 1000000) {
                          unit = 'kL';
                          value = Math.round(value / 1000000 * 10) / 10
                      } else if (value > 1000) {
                          unit = 'L';
                          value = Math.round(value / 1000 * 10) / 10
                      } else {
                          value = Math.round(value * 10) / 10
                      }
                      label += value + ' ' + unit;
                      return label;
                    }
                }
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>